export default "__VITE_ASSET__BVeGKhCG__"